import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-[#FDF6EC]" data-id="element-11">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-12">
        <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-md border-4 border-[#2D6A4F]" data-id="element-13">
          <Shield className="w-10 h-10 text-[#2D6A4F]" data-id="element-14" />
        </div>
        <h3 className="font-heading text-3xl font-bold text-[#2C1810] mb-4" data-id="element-15">
          Garantía Total de 7 Días
        </h3>
        <p className="font-body text-lg text-gray-700 leading-relaxed" data-id="element-16">
          Prueba el método por 7 días completitos. Si no sientes que estás
          comiendo rico, si no ahorras tiempo, o si simplemente no te gusta el
          diseño de la guía, envíanos un correo y te devolvemos el 100% de tu
          dinero. Sin preguntas.
        </p>
      </div>
    </section>;
}